import { isPaymentFieldRequiredInCheckout } from '@checkout/core'

import type { SearchableSelectOption } from '../../components'
import type { CountryItem, PaymentMethodCheckoutFields } from '@checkout/core'

export function normalizeCountryCode(country: string | undefined): string {
  return (country || '').trim().toUpperCase()
}

export function requiresBillingRegion(
  country: string | undefined,
  fields?: PaymentMethodCheckoutFields | null
): boolean {
  return isPaymentFieldRequiredInCheckout({
    fields,
    field: 'billing_region',
    country: normalizeCountryCode(country),
  })
}

export function requiresPostalCode(
  country: string | undefined,
  fields?: PaymentMethodCheckoutFields | null
): boolean {
  return isPaymentFieldRequiredInCheckout({
    fields,
    field: 'billing_postal_code',
    country: normalizeCountryCode(country),
  })
}

export function requiresCardholderName(fields?: PaymentMethodCheckoutFields | null): boolean {
  return isPaymentFieldRequiredInCheckout({
    fields,
    field: 'cardholder_name',
  })
}

export function requiresBillingCountry(fields?: PaymentMethodCheckoutFields | null): boolean {
  return isPaymentFieldRequiredInCheckout({
    fields,
    field: 'billing_country',
  })
}

export function getBillingRegionLabel(): string {
  return 'State / Province'
}

export function createCountryOptions(
  countries: CountryItem[],
  locale = 'en'
): SearchableSelectOption[] {
  let displayNames: Intl.DisplayNames | null = null

  try {
    displayNames = new Intl.DisplayNames([locale, 'en'], { type: 'region' })
  } catch {
    displayNames = null
  }

  return countries
    .map((country) => {
      const code = normalizeCountryCode(country.code)
      const label = displayNames?.of(code) ?? country.name ?? code
      return {
        value: code,
        label,
        keywords: [code, country.name].filter(Boolean),
      }
    })
    .sort((left, right) => left.label.localeCompare(right.label, locale))
}
